export default __webpack_public_path__ + "static/media/elements.2640a907.png";